<ng-container [ngSwitch]="parsedMime">
  <span *ngSwitchCase="'video'" class="material-icons"> play_arrow </span>
  <span *ngSwitchCase="'model'" class="material-icons-outlined"> view_in_ar </span>
  <span *ngSwitchCase="'audio'" class="material-icons-outlined"> volume_up </span>
  <span *ngSwitchCase="'interactive'" class="material-icons-outlined"> code </span>
  <span *ngSwitchCase="'text'" class="material-icons-outlined"> article </span>
  <span *ngSwitchCase="'pdf'" class="material-icons-outlined"> picture_as_pdf </span>
</ng-container>
